import { DailyCardQuote } from './quote';
import { DailyCardCharacterCompass } from './character-compass';
import { DailyCardWildcard } from './wildcard';
import { HomePage } from '@edwin-group/cj-graphql';
import { Suspense, useState } from 'react';
import { DailyCardsLoading } from './loading';
import { PickUpWhereYouLeftOff } from '../pick-up-where-you-left-off';

export const gradients = {
  characterExercise: 'characterExercise-class',
  characterCompass: 'characterCompass-class',
  quote: 'quote-class',
};

export default function DailyCards({ page }: { page: HomePage | null }) {
  const [wildardsSize, setWildardsSize] = useState(0);

  const gridCols = wildardsSize > 1 ? 'lg:grid-cols-4' : 'lg:grid-cols-3';

  return (
    <Suspense fallback={<DailyCardsLoading />}>
      <div className={`grid grid-cols-1 gap-sh-15 md:grid-cols-2 ${gridCols}`}>
        <PickUpWhereYouLeftOff page={page} />
        <DailyCardCharacterCompass page={page} />
        <DailyCardQuote page={page} />
        <DailyCardWildcard setWildardsSize={setWildardsSize} />
      </div>
    </Suspense>
  );
}
